import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const EmailRecipients = (props) => {
    const { emails } = props;
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                padding: 2,
                position: "relative",
            }}
        >
            <Typography
                variant="subtitle2"
                sx={{
                    position: "absolute",
                    top: -12,
                    left: 16,
                    backgroundColor: "background.paper",
                    paddingX: 1,
                    color: "text.secondary",
                }}
            >
                {t("SendEmailDialog.emailRecipients")}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    minHeight: 40,
                    alignItems: "center",
                }}
            >
                {emails.map((email, index) => (
                    <Box
                        key={index}
                        sx={{
                            backgroundColor: "grey.100",
                            border: 1,
                            borderColor: "grey.300",
                            borderRadius: 3,
                            paddingX: 1.5,
                            paddingY: 0.75,
                            fontSize: "0.875rem",
                            color: "text.primary",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {email}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
